import config from "../config/config";
import axios from "axios";

// public: active organisers with their live / upcoming / completed auction counts
export const getOrganiserDirectoryAPI = async () => {
  return await axios({
    method: "get",
    url: `${config.api.base_url}partners/directory`,
    headers: { "Content-type": "application/json; charset=UTF-8" },
  });
};

export default getOrganiserDirectoryAPI;
